import React, { useState, useEffect } from 'react'
import { Backdrop, CircularProgress, Typography } from '@mui/material'
import InfoIcon from '@mui/icons-material/Info'
import useStyleOrganization from './useStyleOrganizations'
import OrganizationTable from './TableNavigable/TableNavigable'
import { useParams } from 'react-router-dom'

import { useDispatch } from 'react-redux'

import BreadcrumbsComponent from './Breadcrumbs/Breadcrumbs'
import {
  SnackBarError,
  SnackBarSuccess
} from '../../../components/SnackBars/SnackBars'
import {
  getOrganizationWithID,
  getTypesOrganizations
} from '../../../redux/actions/Organizations'
import { getSuscriberRefID } from '../../../redux/actions/Suscriber'

export default function OrganizationsOfUSuscriber () {
  const classes = useStyleOrganization()
  const dispatch = useDispatch()

  const { id } = useParams()
  // const location = useLocation()
  const [suscriber, setsuscriber] = React.useState(null)
  const [rows, setRows] = useState([])
  const [types, settypes] = useState([])
  const [loading, setLoading] = useState(false)

  // request get suscriber and set in state or error message
  const handleGetSuscriber = async () => {
    const params = {
      clicod: id
    }
    const getsuscriber = await dispatch(getSuscriberRefID(params))
    if (getsuscriber) {
      setsuscriber(getsuscriber)
      await handlegetorgRequest(getsuscriber.organization_id)
    }
  }

  const handlegetorgRequest = async (orgID) => {
    const response = await dispatch(getOrganizationWithID(orgID))
    response ? setRows((oldState) => [...oldState, response]) : setRows([])
  }

  const getTypesOrgs = async () => {
    const response = await dispatch(getTypesOrganizations())
    settypes(response)
  }
  useEffect(async () => {
    setLoading(true)
    await getTypesOrgs()
    await handleGetSuscriber()
    setLoading(false)
  }, [id])

  return (
    <div className={classes.root}>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <BreadcrumbsComponent />
      <div className={classes.boxtitle}>
        <Typography className={classes.title}>
          Organizaciones asociadas a un suscriptor
        </Typography>
      </div>
      <div className={classes.boxSubTitle}>
        <InfoIcon
          style={{ fontSize: '2rem', color: '#00a78f', marginLeft: 10 }}
        />
        <Typography className={classes.subtitle}>
          La siguiente lista muestra las organizaciones asociadas al suscriptor{' '}
          {suscriber && suscriber.subscriber_name}.
        </Typography>
      </div>

      <SnackBarSuccess />
      <SnackBarError />
      <div className={classes.boxTable}>
        <OrganizationTable
          rows={rows}
          setRows={setRows}
          types={types}
          suscriber={suscriber}
          setLoading={setLoading}
        />
      </div>
    </div>
  )
}
